import { buildTagLink } from '@utils/link';
import NextLink from 'next/link';
import { Container, Item } from './TagList.styles';
import { TagListProps } from './TagList.types';

export const TagList: React.FC<TagListProps> = ({ tags, activeTagId }) => {
  return (
    <Container>
      {tags.map((tag) => (
        <NextLink key={tag.id} href={buildTagLink(tag.slug)} passHref legacyBehavior>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Item active={tag.id === activeTagId}>{tag.name}</Item>
        </NextLink>
      ))}
    </Container>
  );
};
